export default __webpack_public_path__ + "static/outer_bottom-447e86a0479e6749301381c32b0a6b14.png";